
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

export interface MailManageUser {
  id: number;
  email: string;
  status: string;
  quota?: number;
}

export interface MailManageData {
  mailbox?: unknown;
  users?: MailManageUser[];
  mailError?: string;
  activated?: boolean;
}

@Component({
  components: { StatusChip },
})
export default class MailManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: MailManageData;

  public confirmDeleteId: number | null = null;

  public confirmInput: string = '';

  public createFormValid: boolean = false;

  public createEmail: string = '';

  public createPassword: string = '';

  public get website(): Website {
    return this.composite.website;
  }

  public get activated(): boolean {
    return !!(this.panelData && this.panelData.activated);
  }

  public get users(): MailManageUser[] {
    return (this.panelData && this.panelData.users) || [];
  }

  public get confirmValid(): boolean {
    return this.confirmDeleteId !== null
      && this.confirmInput.trim().toLowerCase() === this.website.domain.toLowerCase();
  }

  public get canCreate(): boolean {
    return this.createFormValid && !!this.createEmail && !!this.createPassword;
  }

  public requiredRule(value: string): boolean | string {
    return !!value || 'Required';
  }

  public isEnabled(user: MailManageUser): boolean {
    return (user.status || '').toLowerCase() !== 'disabled';
  }

  public toggleUser(user: MailManageUser): void {
    const status = this.isEnabled(user) ? 'disabled' : 'active';
    this.emitSubmit('toggle-user', { userId: user.id, status });
  }

  public startDelete(userId: number): void {
    this.confirmDeleteId = userId;
    this.confirmInput = '';
  }

  public cancelDelete(): void {
    this.confirmDeleteId = null;
    this.confirmInput = '';
  }

  public confirmDelete(): void {
    if (!this.confirmValid || this.confirmDeleteId === null) {
      return;
    }
    const userId = this.confirmDeleteId;
    this.cancelDelete();
    this.emitSubmit('delete-user', { userId });
  }

  public submitCreate(): void {
    if (!this.canCreate) {
      return;
    }
    this.emitSubmit('create-user', {
      email: this.createEmail,
      password: this.createPassword,
    });
    this.createEmail = '';
    this.createPassword = '';
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
